import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { PROJECTS_ENDPOINTS } from 'src/app/core/api/endpoints/projects.endpoints';
import { ADMIN_ORDERS_ENDPOINTS } from 'src/app/core/api/endpoints/admin-orders.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  private api = inject(ApiService);

  deleteProject(projectIds: number[]) : Observable<any>{
    return this.api.delete(PROJECTS_ENDPOINTS.V1.CONTRACTS, { body: projectIds });
  }

  createProject(data, buttonId): Observable<any> {
    return this.api.post<any>(PROJECTS_ENDPOINTS.V1.CONTRACTS, data, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  updateProject(id, data, buttonId): Observable<any> {
    return this.api.put<any>(PROJECTS_ENDPOINTS.V1.CONTRACT_DETAIL(id), data, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  getProjectByID(id): Observable<any> {
    return this.api.get<any>(PROJECTS_ENDPOINTS.V1.CONTRACT_DETAIL(id));
  }

  getProjectsOrdersByPage(query): Observable<any>{
    return this.api.get(ADMIN_ORDERS_ENDPOINTS.V1.ORDERS_BUSINESS, {params: query});
  }

  getProjects(params): Observable<any> {
    return this.api.get<any>(PROJECTS_ENDPOINTS.V1.CONTRACTS, { params: params });
  }

  addOrdersProject(contractId, data): Observable<any> {
    return this.api.post(PROJECTS_ENDPOINTS.V1.CONTRACT_ORDERS_BULK(contractId), data);
  }

  getTableHeaderData(params): Observable<any> {
    return this.api.get<any>(ADMIN_ORDERS_ENDPOINTS.V1.ORDER_GRID_COLUMN, {params: params});
  }

  customizeColumnGrid(payload:any, params): Observable<any> {
    return this.api.put<any>(ADMIN_ORDERS_ENDPOINTS.V1.ORDER_GRID_COLUMN, payload, {params: params});
  }

  getProjectStatus(): Observable<any> {
   return this.api.get<any>(PROJECTS_ENDPOINTS.V1.PROJECT_STATUS_CHOICES);
  }
}
